import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import "./SuggestedOrderFilter.css"

const SuggestedOrderFilter = ({ column, isFilterActive, activeFilters, allColumns, onClearColumnFilter }) => {
  const { t } = useTranslation();
  const { setFilter } = column;
  const [text, setText] = useState(undefined);

  return (
    <Dropdown
      icon={"filter"}
      text={text || t("ordersTable.filters.noFilter")}
      floating
      labeled
      button
      scrolling
      className={`icon suggested-order-filter button-content${isFilterActive ? " filter-has-clear" : ""}`}
    >
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            setFilter(undefined);
            setText(null);
          }}
          text={t("ordersTable.filters.noFilter")}
        />
        <Dropdown.Item
          onClick={() => {
            setFilter({ type: "globalFilter", threshold: 1 });
            setText(t("ordersTable.filters.orderRequired"));
          }}
          text={t("ordersTable.filters.orderRequired")}
        />
        <Dropdown.Item
          onClick={() => {
            setFilter({ type: "globalFilter", threshold: 0 });
            setText(t("ordersTable.filters.orderNotRequired"));
          }}
          text={t("ordersTable.filters.orderNotRequired")}
        />
        {activeFilters.length > 0 && (
          <>
            <Dropdown.Divider/>
            <Dropdown.Header>{t("ordersTable.activeFilters")}</Dropdown.Header>
            <Dropdown.Divider/>
            {activeFilters.map(filter => {
              const col = allColumns.find(c => c.id === filter.id);
              return (
                <Dropdown.Item key={filter.id} className="active-filter-row" onClick={(e) => e.stopPropagation()}>
                  <div className="active-filter-item">
                    <span>{col ? col.Header : filter.id}</span>
                    <Icon
                      name="trash"
                      onClick={() => onClearColumnFilter(filter.id)}
                      className="layout-trash-icon"
                    />
                  </div>
                </Dropdown.Item>
              );
            })}
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

SuggestedOrderFilter.propTypes = {
  column: PropTypes.object,
  isFilterActive: PropTypes.bool,
  activeFilters: PropTypes.array,
  allColumns: PropTypes.array,
  onClearColumnFilter: PropTypes.func,
};

SuggestedOrderFilter.defaultProps = {
  column: {},
  isFilterActive: false,
  activeFilters: [],
  allColumns: [],
  onClearColumnFilter: () => {},
};

export default SuggestedOrderFilter;
